import account from './account'
import layout from './layout'
import loading from './loading'
import pseudo from './pseudo'
import theme from './theme'

export default {
  namespaced: true,
  modules: {
    loading: loading,
    account: account,
    layout: layout,
    pseudo: pseudo,
    theme: theme
  },
  state () {
    return {}
  },
  getters: {},
  mutations: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/common/store/index.js